import config from "appConfig";
import { LayoutComponent } from "@jelly/lesson";

const component: LayoutComponent = {
  variant: "layout",
  data: {
    type: "table",
    options: {
      cols: 3,
      rows: 2,
      rowsSize: [3, 2],
      colSpan: {
        "0:0": 3,
      },
      gap: "17px",
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              styles: {
                alignItems: "flex-end",
              },
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/03/case-02/principle/6-data-preparation.png`,
                  viewType: "contain",
                  styles: {
                    maxHeight: "271px",
                  },
                },
              },
            },
          },
        ],
        [
          null,
          {
            variant: "blockContainer",
            data: {
              styles: {
                alignItems: "flex-start",
              },
              block: {
                type: "text",
                options: {
                  data:
                    "For a realistic simulation of vehicle sound a detailed characterization of different sound sources, including their behavior and strength at different operating points, is required. In practice, this is achieved through the process of transfer path analysis (TPA), which separates and quantifies the contributions of relevant sound sources along different paths (e.g. air-borne or structure-borne) by means of adequate source-receiver sensor configurations. For best results a binaural TPA should be done utilizing an artificial head as a receiver.",
                  styles: {
                    fontSize: "12px",
                    fontWeight: "600",
                  },
                  scrollbars: false,
                },
              },
            },
          },
        ],
      ],
    },
  },
};

export default component;
